import { useRef, useEffect, useState } from "react";
import { motion } from "framer-motion";
import NewCards from "./NewCards";
import "../styles/Projects.css";

//this has become a re-usable component!
export default function Designs({ data, tabTitle }) {
  const [visibleElements, setVisibleElements] = useState({});
  const elementRefs = useRef(new Map());

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const updatedVisibility = {};
        entries.forEach((entry) => {
          updatedVisibility[entry.target.dataset.id] = entry.isIntersecting;
        });
        setVisibleElements((prevVisibility) => ({
          ...prevVisibility,
          ...updatedVisibility,
        }));
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.1,
      },
    );

    elementRefs.current.forEach((ref, id) => {
      if (ref) {
        observer.observe(ref);
      }
    });

    return () => {
      elementRefs.current.forEach((ref) => {
        if (ref) {
          observer.unobserve(ref);
        }
      });
    };
  }, []);

  return (
    <div className="projects-container">
      <div className="projects-header">
        <span>Selected work</span>
        <h1 className="projects-h1">{tabTitle}</h1>
        <p>
          A collection of websites I've designed and developed for clients
          across events, wellness, and small business.
        </p>
      </div>

      <div className="design__container">
        {data.map((obj) => (
          <div
            key={obj.id}
            data-id={obj.id}
            className={`card-container ${
              visibleElements[obj.id] ? "observer-visible" : ""
            }`}
            ref={(el) => {
              elementRefs.current.set(obj.id, el);
            }}
          >
            <motion.div
              className="motion-div"
              initial={{ x: "-100%" }}
              animate={{ x: "0%" }}
            >
              <NewCards
                link={obj.link}
                src={obj.src}
                info={obj.info}
                about={obj.about}
                tags={obj.tags}
              />
            </motion.div>
          </div>
        ))}
      </div>
    </div>
  );
}
